
import React, {  useEffect, useState } from "react";
import Step1 from "./component/Step1";
import Step2 from "./component/Step2";
import Step3 from "./component/Step3";
import { Box, styled, Typography } from "@mui/material";
// import ActivateLogo from "../../assets/images/activate-logo.svg";
import Header from "../profile/component/Header";
import Step4 from "./component/Step4";
import { useParams } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
const RoleReviewForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    coreFocusAreas: [],
  });
  // const [isJwtUser, setIsJwtUser] = useState(false);
  const { param } = useParams();
  

  useEffect(() => {
    if (param) {
      try {
        const decoded = jwtDecode(param);
        if (decoded && decoded.user) {
          // setIsJwtUser(true);
        }
      } catch (error) {
        console.error("Invalid JWT token:", error);
        // setIsJwtUser(false);
      }
    }
  }, [param]);

  const handleNext = (data) => {
    setFormData((prev) => ({
      ...prev,
      ...data, // Merge new data with the existing formData
    }));
    setCurrentStep((prev) => prev + 1);
  };
  // const handleUpdateFormData = (updatedData) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     ...updatedData,
  //   }));
  // };

  const handlePrev = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };
  // const handleBackToStep3 = () => {
  //   setCurrentStep(3); // Directly set to Step 3
  // };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return <Step1 currentStep={currentStep} onNext={handleNext} />;
      case 2:
        return (
          <Step2
            currentStep={currentStep}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        );
      // case 3:
      //   return (
      //     <Step3
      //       currentStep={currentStep}
      //       onPrev={handlePrev}
               
      //       formData={formData}
      //     />
      //   );
      case 3:
        return <Step3 currentStep={currentStep} onNext={handleNext} onPrev={handlePrev} formData={formData}/>;
      case 4:  // Add Step 4
        return <Step4 currentStep={currentStep} onPrev={handlePrev}/>;
     
      default:
        return <div>Form Completed</div>;
    }
  };

  return (
    <>
    <Header />
    <SectionWrap component="section">
      
      <ContainerWrap>
        <RowWrap>
          <Col12Wrap sx={{ textAlign: "center", marginBottom: "20px" }}>
            {/* <img
              src={ActivateLogo}
              alt="Activate Logo"
              width="238"
              height="90"
            /> */}
          <Box >
              <Typography  sx={{ fontSize: "25px", textAlign:"center" ,fontWeight: "500", margin: "0 10px", color: "#2C2C2E" }}>Role Review</Typography>
             
              </Box>
          </Col12Wrap>
          <Col12Wrap>
            <FormFirstBoxWrap
              sx={{
                paddingTop: "25px",
                paddingBottom: "22px",
                textAlign: "center",
              }}
            >
              <StepCount>Step {currentStep} of 4</StepCount>

              <StepProgress
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <StepProgressInner 
                  className={currentStep >= 1 ? "active" : ""}
                />
                <StepProgressInner
                  className={currentStep >= 2 ? "active" : ""}
                />
                <StepProgressInner
                  className={currentStep >= 3 ? "active" : ""}
                />
                <StepProgressInner
                  className={currentStep >= 4 ? "active" : ""}
                />
              </StepProgress>
            </FormFirstBoxWrap>
          </Col12Wrap>
          <Col12Wrap>{renderStepContent()}</Col12Wrap>
        </RowWrap>
      </ContainerWrap>
    </SectionWrap>
    </>
  );
};

export default RoleReviewForm;

const StepProgress = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));
const StepProgressInner = styled(Box)(() => ({
  width: "100%",
  position: "relative",
  "&.active": {
    "&:after": {
      background: "#F28021",
    },
    "&:before": {
      background: "#F28021",
    },
  },
  "&:after": {
    content: "''",
    position: "absolute",
    bottom: "-28px",
    width: "13px",
    height: "13px",
    background: "#E0E0E0",
    borderRadius: "50%",
    zIndex: "1",
  },
  "&:before": {
    content: "''",
    position: "absolute",
    right: "50%",
    bottom: "-23px",
    width: "100%",
    height: "3px",
    background: "#E0E0E0",
  },
  "&:first-of-type": {
    "&:before": {
      content: "none",
    },
  },
}));
const SectionWrap = styled(Box)(() => ({
  padding: "30px 0 100px",
}));
const ContainerWrap = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1170px",
  paddingLeft: "15px",
  paddingRight: "15px",
  marginLeft: "auto",
  marginRight: "auto",
}));
const RowWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  marginLeft: "-15px",
  marginRight: "-15px",
}));
const Col12Wrap = styled(Box)(() => ({
  flex: "0 0 auto",
  width: "100%",
  maxWidth: "100%",
  paddingLeft: "15px",
  paddingRight: "15px",
}));
const FormFirstBoxWrap = styled(Box)(() => ({
  padding: "50px 150px",
  background: "#ffffff",
  maxWidth: "1030px",
  borderTop: "2px solid #1085AB",
  borderRadius: "7px 7px 0px 0px",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "16px",
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.05)",
  "@media (max-width: 1199px)": {
    maxWidth: "100%",
    paddingLeft: "100px",
    paddingRight: "100px",
  },
  "@media (max-width: 991px)": {
    paddingLeft: "50px",
    paddingRight: "50px",
  },
  "@media (max-width: 575px)": {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
}));
const StepCount = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: "500",
  lineHeight: "1.445",
  color: "#000000",
}));


